export const DEBUG_MODE_STORAGE_KEY = 'PICKUPBIRD_DEBUG_MODE';

export const isDebugModeEnabled = (): boolean => {
    if (typeof window === 'undefined') return false;

    try {
        return localStorage.getItem(DEBUG_MODE_STORAGE_KEY) === 'true';
    } catch (_) {
        return false;
    }
};
